/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppDeliverRouteImport } from './routes/_app/deliver'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppDepositsIndexRouteImport } from './routes/_app/deposits/index'
import { Route as AppDepositsIdRouteImport } from './routes/_app/deposits/$id'
import { Route as AppDepositsNewRouteImport } from './routes/_app/deposits/new'
import { Route as AppReportsKindRouteImport } from './routes/_app/reports/$kind'
import { Route as AppSettingsCurrenciesRouteImport } from './routes/_app/settings/currencies'
import { Route as AppSettingsDepositSettingsRouteImport } from './routes/_app/settings/deposit-settings'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsGroupsIdServicesRouteImport } from './routes/_app/settings/groups/$id.services'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppDeliverRoute = AppDeliverRouteImport.update({
  id: '/deliver',
  path: '/deliver',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDepositsIndexRoute = AppDepositsIndexRouteImport.update({
  id: '/deposits/',
  path: '/deposits/',
  getParentRoute: () => AppRoute,
} as any)
const AppDepositsIdRoute = AppDepositsIdRouteImport.update({
  id: '/deposits/$id',
  path: '/deposits/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDepositsNewRoute = AppDepositsNewRouteImport.update({
  id: '/deposits/new',
  path: '/deposits/new',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsKindRoute = AppReportsKindRouteImport.update({
  id: '/reports/$kind',
  path: '/reports/$kind',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCurrenciesRoute = AppSettingsCurrenciesRouteImport.update({
  id: '/settings/currencies',
  path: '/settings/currencies',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDepositSettingsRoute =
  AppSettingsDepositSettingsRouteImport.update({
    id: '/settings/deposit-settings',
    path: '/settings/deposit-settings',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIdServicesRoute =
  AppSettingsGroupsIdServicesRouteImport.update({
    id: '/settings/groups/$id/services',
    path: '/settings/groups/$id/services',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/deliver': typeof AppDeliverRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/deposits/$id': typeof AppDepositsIdRoute
  '/deposits/new': typeof AppDepositsNewRoute
  '/reports/$kind': typeof AppReportsKindRoute
  '/settings/currencies': typeof AppSettingsCurrenciesRoute
  '/settings/deposit-settings': typeof AppSettingsDepositSettingsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/deposits/': typeof AppDepositsIndexRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesByTo {
  '/deliver': typeof AppDeliverRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/deposits/$id': typeof AppDepositsIdRoute
  '/deposits/new': typeof AppDepositsNewRoute
  '/reports/$kind': typeof AppReportsKindRoute
  '/settings/currencies': typeof AppSettingsCurrenciesRoute
  '/settings/deposit-settings': typeof AppSettingsDepositSettingsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/deposits': typeof AppDepositsIndexRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/deliver': typeof AppDeliverRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/deposits/$id': typeof AppDepositsIdRoute
  '/_app/deposits/new': typeof AppDepositsNewRoute
  '/_app/reports/$kind': typeof AppReportsKindRoute
  '/_app/settings/currencies': typeof AppSettingsCurrenciesRoute
  '/_app/settings/deposit-settings': typeof AppSettingsDepositSettingsRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/deposits/': typeof AppDepositsIndexRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/deliver'
    | '/auth/launch'
    | '/deposits/$id'
    | '/deposits/new'
    | '/reports/$kind'
    | '/settings/currencies'
    | '/settings/deposit-settings'
    | '/settings/users'
    | '/deposits/'
    | '/settings/groups/'
    | '/settings/groups/$id/services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/deliver'
    | '/auth/launch'
    | '/'
    | '/deposits/$id'
    | '/deposits/new'
    | '/reports/$kind'
    | '/settings/currencies'
    | '/settings/deposit-settings'
    | '/settings/users'
    | '/deposits'
    | '/settings/groups'
    | '/settings/groups/$id/services'
  id:
    | '__root__'
    | '/_app'
    | '/_app/deliver'
    | '/auth/launch'
    | '/_app/'
    | '/_app/deposits/$id'
    | '/_app/deposits/new'
    | '/_app/reports/$kind'
    | '/_app/settings/currencies'
    | '/_app/settings/deposit-settings'
    | '/_app/settings/users'
    | '/_app/deposits/'
    | '/_app/settings/groups/'
    | '/_app/settings/groups/$id/services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deliver': {
      id: '/_app/deliver'
      path: '/deliver'
      fullPath: '/deliver'
      preLoaderRoute: typeof AppDeliverRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/deposits/': {
      id: '/_app/deposits/'
      path: '/deposits'
      fullPath: '/deposits/'
      preLoaderRoute: typeof AppDepositsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deposits/$id': {
      id: '/_app/deposits/$id'
      path: '/deposits/$id'
      fullPath: '/deposits/$id'
      preLoaderRoute: typeof AppDepositsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deposits/new': {
      id: '/_app/deposits/new'
      path: '/deposits/new'
      fullPath: '/deposits/new'
      preLoaderRoute: typeof AppDepositsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$kind': {
      id: '/_app/reports/$kind'
      path: '/reports/$kind'
      fullPath: '/reports/$kind'
      preLoaderRoute: typeof AppReportsKindRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/currencies': {
      id: '/_app/settings/currencies'
      path: '/settings/currencies'
      fullPath: '/settings/currencies'
      preLoaderRoute: typeof AppSettingsCurrenciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/deposit-settings': {
      id: '/_app/settings/deposit-settings'
      path: '/settings/deposit-settings'
      fullPath: '/settings/deposit-settings'
      preLoaderRoute: typeof AppSettingsDepositSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/$id/services': {
      id: '/_app/settings/groups/$id/services'
      path: '/settings/groups/$id/services'
      fullPath: '/settings/groups/$id/services'
      preLoaderRoute: typeof AppSettingsGroupsIdServicesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDeliverRoute: typeof AppDeliverRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDepositsIdRoute: typeof AppDepositsIdRoute
  AppDepositsNewRoute: typeof AppDepositsNewRoute
  AppReportsKindRoute: typeof AppReportsKindRoute
  AppSettingsCurrenciesRoute: typeof AppSettingsCurrenciesRoute
  AppSettingsDepositSettingsRoute: typeof AppSettingsDepositSettingsRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppDepositsIndexRoute: typeof AppDepositsIndexRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsGroupsIdServicesRoute: typeof AppSettingsGroupsIdServicesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDeliverRoute: AppDeliverRoute,
  AppIndexRoute: AppIndexRoute,
  AppDepositsIdRoute: AppDepositsIdRoute,
  AppDepositsNewRoute: AppDepositsNewRoute,
  AppReportsKindRoute: AppReportsKindRoute,
  AppSettingsCurrenciesRoute: AppSettingsCurrenciesRoute,
  AppSettingsDepositSettingsRoute: AppSettingsDepositSettingsRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppDepositsIndexRoute: AppDepositsIndexRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsGroupsIdServicesRoute: AppSettingsGroupsIdServicesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
